export default __webpack_public_path__ + "static/vampireguide-cc6cf5b23fa86fa564aac08a797e5fa6.jpg";